import { isJobTypeLabel, isAServiceGroup } from '../../utils/label';
import {
    LabelSummary,
    LocationInfo,
    PluginWorkSite,
    WorkSite,
} from '../../models';

export const jobTitleGenerator = (job: PluginWorkSite | WorkSite) => {
    if (job.title) {
        return job.title;
    }

    const labels = job.labels || [];
    const labelSummaries: LabelSummary[] = labels.map((label) =>
        'toSummary' in label && typeof label.toSummary === 'function'
            ? label.toSummary()
            : label
    );

    const jobType = labelSummaries.find((l) => isJobTypeLabel(l))?.name;
    const service = labelSummaries.find((l) => isAServiceGroup(l))?.name;

    return `${service ? service + ' ' : ''}${jobType || 'Job'}${
        job.locationInfo ? ' in ' + getLocationInfo(job.locationInfo) : ''
    }`;
};

const getLocationInfo = (
    locationInfo:
        | Omit<
              LocationInfo,
              'address1' | 'address2' | 'googlePlaceId' | 'googlePlusCode'
          >
        | undefined
) => {
    if (locationInfo?.neighborhood) {
        return locationInfo?.neighborhood;
    }

    if (locationInfo?.city) {
        return locationInfo?.city;
    }

    return `${locationInfo?.zip}`;
};
